module.exports = __webpack_public_path__ + "static/media/traca_thumb.18859b2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/traca_thumb.png
// module id = 169
// module chunks = 0